import { uploadFileErrorMessage } from "common/consts/uploadFileErrors";
import Modal from "components/modal/Modal";
import ModalFooter from "components/modal/ModalFooter";

import "./FileUploadErrorModal.scss";

export type Props = {
  failMessage: string;
  setFailed: (failed: boolean) => void;
};

export default function FileUploadErrorModal({ failMessage, setFailed }) {
  const errorMessage = uploadFileErrorMessage[failMessage];

  return (
    <Modal
      size="xs"
      onDismiss={() => setFailed(false)}
      modalTitle="upload failed"
      header={<h1 className="m-0">{errorMessage.title}</h1>}
      footer={
        <ModalFooter
          hideCancel
          onConfirm={() => setFailed(false)}
          confirmText="Fortsätt"
          justifyActions="end"
        />
      }
    >
      <p className="file-error-message">{errorMessage.message}</p>
    </Modal>
  );
}
